/**
 * recommendModules/helpers/preFilterVehicles.js
 * Araçları ön-filtreleyen yardımcı fonksiyon
 */

const { calculateDistancePriority } = require("../calculator/calculateDistancePriority");
const { DISTANCE_LIMITS, VEHICLE_CAPACITY } = require("../constants");

/**
 * Araçların ön-filtrelenmesi için yardımcı fonksiyon
 * @param {Array} vehicles - Araçlar listesi
 * @param {Object} order - Sipariş detayları
 * @param {Function} isSuitableFn - Uygunluk kontrol fonksiyonu
 * @param {number} areaSensitivity - Mesafe hassasiyeti (km)
 * @param {Object} vehicleInventories - Araç envanterleri (opsiyonel)
 * @param {Object} cachedDistances - Önceden hesaplanmış mesafeler (opsiyonel)
 * @returns {Array} Filtrelenmiş araçlar listesi
 */
function preFilterVehicles(vehicles, order, isSuitableFn, areaSensitivity = DISTANCE_LIMITS.DEFAULT_AREA_SENSITIVITY, vehicleInventories = {}, cachedDistances = null) {
  // Null/undefined check
  if (!vehicles) return [];

  // EKIPMAN BAZLI PLANLAMA: Önce ekipman kontrolü, sonra normal filtreleme
  if (order.requiredEquipmentCategories && order.requiredEquipmentCategories.length > 0) {
    // Ekipman kontrolü için yardımcı fonksiyon
    const hasRequiredEquipment = (vehicle) => {
      const vehicleInventory = (vehicleInventories && vehicleInventories[vehicle.id]) || [];
      const vehicleCategoryMap = {};

      vehicleInventory.forEach(item => {
        if (!item || !item.category) return;

        // Status kontrolü - sadece AKTIF ekipmanları say
        const isActive = item.status === 'AKTIF' ||
                        (item.current_location === 'ARACTA' && item.is_deleted === 0);
        if (!isActive) return;

        if (!vehicleCategoryMap[item.category]) {
          vehicleCategoryMap[item.category] = [];
        }
        vehicleCategoryMap[item.category].push(item);
      });

      // Tüm gerekli kategoriler araçta var mı kontrol et
      return order.requiredEquipmentCategories.every(category => {
        const categoryItems = vehicleCategoryMap[category] || [];
        return categoryItems.length > 0;
      });
    };

    // EKIPMANLI ARAÇLAR: Mesafe/isSuitable limiti YOK - Türkiye geneli
    const vehiclesWithEquipment = vehicles.filter(hasRequiredEquipment);

    // EKIPMANSIZ ARAÇLAR: Normal isSuitable + mesafe kontrolü
    const maxDistance = order.tonnage <= VEHICLE_CAPACITY.SMALL_ORDER_LIMIT
      ? areaSensitivity
      : areaSensitivity * DISTANCE_LIMITS.LARGE_ORDER_MULTIPLIER;

    const vehiclesWithoutEquipment = vehicles
      .filter(v => !hasRequiredEquipment(v))
      .filter(isSuitableFn)
      .filter(vehicle => {
        const distancePriority = calculateDistancePriority(order, vehicle, cachedDistances);
        return distancePriority < maxDistance;
      });

    const suitableVehicles = [...vehiclesWithEquipment, ...vehiclesWithoutEquipment];

    // Eğer ekipman filtresi sonrası araç kalmadıysa, metadata ekle
    if (suitableVehicles.length === 0 && vehicles.length > 0) {
      suitableVehicles.equipmentFilterMetadata = {
        requiredCategories: order.requiredEquipmentCategories,
        vehiclesBeforeFilter: vehicles.length,
        failedDueToEquipment: true
      };
    }

    return suitableVehicles;
  }

  // NORMAL PLANLAMA (ekipman yok)
  let suitableVehicles = vehicles.filter(isSuitableFn);

  const maxDistance = order.tonnage <= VEHICLE_CAPACITY.SMALL_ORDER_LIMIT
    ? areaSensitivity
    : areaSensitivity * DISTANCE_LIMITS.LARGE_ORDER_MULTIPLIER;

  suitableVehicles = suitableVehicles.filter(vehicle => {
    const distancePriority = calculateDistancePriority(order, vehicle, cachedDistances);
    return distancePriority < maxDistance;
  });

  return suitableVehicles;
}

module.exports = preFilterVehicles;